// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReviewsAndQuestions_wrapper__UgUtO"};